// All changes must also be made to the _layout.scss file in this same directory.
const pageMaxWidth = 1140;

export const totalColumns = 12;

const mediumLine = 840;
const largeLine = 1440;

export const belowMedium = `(min-width: 0px) and (max-width: ${mediumLine}px)`;
export const aboveMedium = `(min-width: ${mediumLine + 1}px)`;
const belowLargeLine = `(max-width: ${largeLine}px)`;
const aboveLargeLine = `(min-width: ${largeLine + 1}px)`;

const gridGap = 26;
